import { humanizeDate } from "../../utils/formatters";
import { formatNumber } from "@ildes/pipes/format-number.pipe";
export const actions = {
    seeDetail: 'SEE_DETAIL',
};
function getProp( object, keys, defaultVal ){
  keys = Array.isArray( keys )? keys : keys.split('.');
  object = object[keys[0]];
  if( object && keys.length>1 ){
    return getProp( object, keys.slice(1), defaultVal );
  }
  return object === undefined? defaultVal : object;
}

const columns = {
  'projectName': {
    name: 'Proyecto',
    path: 'project.name',
  },
  'receptor': {
    name: 'Receptor',
    parse: (bill) => {
      return `${bill.receptor?.name} ${bill.receptor?.surname}`
    }
  },
  'email': {
    name: 'Email',
    path: 'receptor.email',
  },
  'number': {
    name: '#Precuenta',
    path: 'number',
  },
  'realNumber': {
    name: '#Factura',
    path: 'realNumber',
  },
  'cost': {
    name: 'Coste',
    parse: (bill) => {
      return formatNumber(bill.cost);
    }
  },
  'taxes': {
    name: 'Impuestos',
    parse: (bill) => {
      return`${bill.taxes?.amount || 0}%`;
    }
  },
  'costTaxes': {
    name: 'Coste(+impuestos)',
    parse: (bill) => {
        const cost = {
            amount: bill.cost.amount + (bill.cost.amount * bill.taxes?.amount || 0),
            currency: bill.cost.currency
        }
        return formatNumber(cost);
    }
  },
  'dispatchedDate': {
    name: 'Fecha de expedición',
    parse: (bill) => humanizeDate(bill.dispatchedDate),
  },
  'payed': {
    name: 'Pagado',
    parse: (bill) => bill.payed ? 'Sí': 'No',
  },
  'actionDetail': {
    name: '',
    parse: () => 'Ver detalle',
    config: {
        link: {
            action: actions.seeDetail,
        },
    }
  },
};

export const resumedColumns = {
  ...columns
};

export const detailedColumns = {
  ...columns
}

export const parse = (items, columns) => {
  const columnValues = Object.values(columns);
  const columnNames = Object.keys(columns);


  return items.map((item) => {
    return columnValues.map((columnConfig, index) => {
      let value = '';
      if (columnConfig.parse) {
        value = columnConfig.parse(item);
      }
      else if (columnConfig.path) {
        value = getProp(item, columnConfig.path, '-');
      }
      else if (columnConfig.descriptions) {
        value = columnConfig.descriptions[item[columnNames[index]]];
      } else {
        value = item[columnNames[index]] || '-';
      }

      return {
        item,
        value,
        ...columnConfig.config && { config: columnConfig.config }
      }
    })
  })
}


